module.exports = __webpack_public_path__ + "static/img/product_3_2.1865dbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/product_3_2.png
// module id = 9xeo
// module chunks = 34